export const nav = [
    "home",
    "about",
    "skills",
    "experience",
    "portfolio",
    "contacts"
];